import { render, staticRenderFns } from "./fankuiRecord.vue?vue&type=template&id=82e4fa58&scoped=true&"
import script from "./fankuiRecord.vue?vue&type=script&lang=js&"
export * from "./fankuiRecord.vue?vue&type=script&lang=js&"
import style0 from "./fankuiRecord.vue?vue&type=style&index=0&id=82e4fa58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e4fa58",
  null
  
)

export default component.exports